import { render, staticRenderFns } from "./EventFormDetail.vue?vue&type=template&id=2c161b29&scoped=true"
import script from "./EventFormDetail.vue?vue&type=script&lang=js"
export * from "./EventFormDetail.vue?vue&type=script&lang=js"
import style0 from "./EventFormDetail.vue?vue&type=style&index=0&id=2c161b29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c161b29",
  null
  
)

export default component.exports